var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextArea } from "native-base";
import FormControlWrapper from "./FormControlWrapper";
const FormTextAreaControl = (_a) => {
    var { isInvalid = false, isRequired = false, error, hint, label, placeholder, labelProps, textareaHeight = 154 } = _a, rest = __rest(_a, ["isInvalid", "isRequired", "error", "hint", "label", "placeholder", "labelProps", "textareaHeight"]);
    return (_jsx(FormControlWrapper, Object.assign({ isInvalid: isInvalid, isRequired: isRequired, error: error, hint: hint, label: label, labelProps: labelProps }, { children: _jsx(TextArea, Object.assign({ autoCompleteType: "off", h: textareaHeight, placeholder: placeholder, isInvalid: isInvalid, isRequired: isRequired }, rest)) })));
};
export default FormTextAreaControl;
